export enum UserOriginEnum {
  ISA_LAB = 1,
  PARTNER,
  CUSTOMER,
}
